import React, { useState, useRef, useEffect, useMemo } from 'react';
import {
    Search,
    MoreHorizontal,
    ChevronsUpDown,
    ChevronLeft,
    ChevronRight,
    X,
    Copy,
    SquareArrowOutUpRight,
    Funnel,
    Pencil,
    Info,
    ChevronUp,
    ChevronDown
} from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import Tooltip from '../addentities/Tooltip';
import apiHelper from '../../apiHelper';

const dummyData = [
    {
        id: 1,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 232,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 },
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 2,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 43,
        reserved: 2,
        pending: [
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 3,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 67,
        reserved: 1,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 4,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 12,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 5,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 86,
        reserved: 0,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 6,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 34,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 7,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 754,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 8,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 65,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 9,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Xiaomi',
        category: 'Mobile Phones',
        available: 23,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 10,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Mint',
        status: 'Active',
        iD: '12345',
        brand: 'Xiaomi',
        category: 'Mobile Phones',
        available: 123,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    }
];

const dummyDataArchived = [
    {
        id: 1,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 232,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 },
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 2,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 43,
        reserved: 2,
        pending: [
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 3,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Activated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 67,
        reserved: 1,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 4,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 12,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 5,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Apple',
        category: 'Mobile Phones',
        available: 86,
        reserved: 0,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 6,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'New',
        grading: 'Unactivated',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 34,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 7,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 754,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 8,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 512 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Samsung',
        category: 'Mobile Phones',
        available: 65,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 9,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 1 TB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Pristine',
        status: 'Active',
        iD: '12345',
        brand: 'Xiaomi',
        category: 'Mobile Phones',
        available: 23,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    },
    {
        id: 10,
        name: 'iPhone 16 Pro Max',
        variant: 'White Titanium, 256 GB',
        avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
        condition: 'Used',
        grading: 'Mint',
        status: 'Active',
        iD: '12345',
        brand: 'Xiaomi',
        category: 'Mobile Phones',
        available: 123,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    }
];

// Drawer -> Stock instances tab data
const imeiStockData = [
    {
        id: 1,
        imei: '35334107 123456 2',
        location: 'Bedok',
        available: 232,
        reserved: 2,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 },
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 2,
        imei: '35334107 123456 2',
        location: '(Pending)',
        available: 43,
        reserved: 2,
        pending: [
            { type: 'Outbounding', color: '#FD7E14', count: 10 },
            { type: 'Transferring', color: '#6C757D', count: 9 }
        ]
    },
    {
        id: 3,
        imei: '35334107 123456 2',
        location: 'HQ',
        available: 67,
        reserved: 6,
        pending: [
            { type: 'Inbounding', color: '#198754', count: 5 }
        ]
    }
];

// Drawer -> Transaction History tab Data
const transactionData = [
    {
        time: '2024-12-01 23:34',
        type: 'Stock-In',
        qty: 1,
        channel: 'Purchase',
        price: 'SGD 620.00'
    },
    {
        time: '2024-12-01 23:34',
        type: 'Stock-Out',
        qty: 1,
        channel: 'Carousell',
        price: 'SGD 620.00'
    },
    {
        time: '2024-12-01 23:34',
        type: 'Reserved',
        qty: 1,
        channel: 'Store',
        price: 'SGD 620.00'
    }
];

const PAGE_SIZE = 10; // Display all 10 rows on one page

export default function StockList() {
    const [activeTab, setActiveTab] = useState('stock-list');
    const history = useHistory();
    const location = useLocation();

    // Breadcrumbs (you can adjust these if needed)
    const breadcrumbs = ["Stock", "Stock List"];

    // Search, pagination, and multi‐selection state
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    // Archived Branch Tab
    const [archivedSearchTerm, setArchivedSearchTerm] = useState('');
    const [archivedCurrentPage, setArchivedCurrentPage] = useState(1);
    const [archivedSelectedIds, setarchivedSelectedIds] = useState([]);
    const [archivedStatusFilter, setArchivedStatusFilter] = useState('');

    // “Suppress highlight” flag: if true, even checked rows will not be highlighted
    const [suppressHighlight, setSuppressHighlight] = useState(false);

    // Single‐row Drawer state (unchanged)
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerTab, setDrawerTab] = useState('entity-info');
    const [drawerTab2, setDrawerTab2] = useState('entity-info2');
    const [selectedRow, setSelectedRow] = useState(null);
    const filterPopupRef = useRef(null);
    const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });


    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const filterButtonRef = useRef(null);
    const [filterCount, setFilterCount] = useState(0);


    useEffect(() => {
        async function fetchStockInstances() {
            setLoading(true);
            setError(null);
            try {
                // Replace with your real endpoint
                const response = await apiHelper('inventory/stocks/', 'GET');
                const data = await response.json();
                console.log(data);
                setStockData(data);  // assuming data is an array of stock instances
            } catch (err) {
                setError('Failed to load stock instances');
                console.error(err);
            } finally {
                setLoading(false);
            }
        }

        fetchStockInstances();
    }, []);


const filtered = useMemo(() => {
  const term = searchTerm.toLowerCase();

  let results = stockData.filter(d => {
    //  Search filter
    const matchesSearch =
      d.barcode?.toLowerCase().includes(term) ||
      d.condition?.toLowerCase().includes(term) ||
      d.spu_name?.toLowerCase().includes(term) ||
      d.sku?.sku_code?.toLowerCase().includes(term) ||
      d.stock_quantity?.toString().includes(term) ||
      d.warranty_period?.toLowerCase().includes(term) ||
      d.brand_name?.toLowerCase().includes(term) ||
      d.category_name?.toLowerCase().includes(term);

    // Status filter
    const matchesStatus =
      selectedStatuses.length === 0 ||
      selectedStatuses.includes(d.spu_status_text);

    return matchesSearch && matchesStatus;
  });

  //  Apply sorting
  if (sortConfig.key) {
    results = [...results].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? "";
      const bVal = b[sortConfig.key] ?? "";

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  return results;
}, [searchTerm, selectedStatuses, stockData, sortConfig]);

const handleSort = (key) => {
  setSortConfig((prev) => {
    if (prev.key === key) {
      // toggle asc/desc
      return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
    }
    return { key, direction: "asc" };
  });
};


    // Filtered + paginated data for archived
    const archivedFiltered = useMemo(() => {
        const term = archivedSearchTerm.toLowerCase();

        return dummyDataArchived.filter(d => {
            const matchesSearch =
                d.name.toLowerCase().includes(term) ||
                d.iD.toLowerCase().includes(term) ||
                d.brand.toLowerCase().includes(term) ||
                d.variant.toLowerCase().includes(term) ||
                d.condition.toLowerCase().includes(term) ||
                d.grading.toLowerCase().includes(term) ||
                d.category.toLowerCase().includes(term) ||
                d.available.toString().includes(term) ||
                d.reserved.toString().includes(term) ||
                d.pending?.some(p => p.type.toLowerCase().includes(term)); // ✅ search pending type


            const matchesStatus =
                archivedStatusFilter === '' || d.status.toLowerCase() === archivedStatusFilter.toLowerCase();

            return matchesSearch && matchesStatus;
        });
    }, [archivedSearchTerm, archivedStatusFilter]);


    // Pagination calculations
    const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
    const pageData = filtered.slice(
        (currentPage - 1) * PAGE_SIZE,
        currentPage * PAGE_SIZE
    );
    console.log('this is pagedata', pageData);
    const archivedTotalPages = Math.ceil(archivedFiltered.length / PAGE_SIZE);
    const archivedPageData = archivedFiltered.slice(
        (archivedCurrentPage - 1) * PAGE_SIZE,
        archivedCurrentPage * PAGE_SIZE
    );

    // Toggle selecting a single row (checkbox)
    const toggleSelect = id => {
        setSelectedIds(ids => {
            const newIds = ids.includes(id)
                ? ids.filter(x => x !== id)
                : [...ids, id];

            // As soon as user toggles a checkbox, we should no longer suppress highlight
            setSuppressHighlight(false);
            return newIds;
        });
    };

    // Toggle “select all” on the current page
    const toggleAll = () => {
        setSelectedIds(prev => {
            const next =
                prev.length === pageData.length
                    ? []
                    : pageData.map(d => d.id);

            // As soon as user toggles “select all,” remove the suppression
            setSuppressHighlight(false);
            return next;
        });
    };

    // When a row (except its checkbox) is clicked, open the single‐row drawer
    const onRowClick = (row) => {
        setSelectedRow(row);
        setDrawerTab('entity-info');
        setDrawerTab2('entity-info2');
        setDrawerOpen(true);
    };

    // Dropdown (ellipsis) state & refs (unchanged)
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRefs = useRef({});
    const drawerRef = useRef(null);

    // Close single‐row Drawer when clicking outside
    useEffect(() => {
        function handleClickOutsideDrawer(event) {
            if (!drawerOpen) return;

            const target = event.target;

            // 1) click inside main drawer -> keep open
            if (drawerRef.current && drawerRef.current.contains(target)) return;

            // 2) click inside filter drawer -> keep main open
            if (filterDrawerRef.current && filterDrawerRef.current.contains(target)) return;

            // 3) ignore toolbar/dropdowns if they are part of drawer UI
            if (toolbarRef.current && toolbarRef.current.contains(target)) return;
            if (dropdownRef.current && dropdownRef.current.contains(target)) return;
            // add more ignores if you have other floating popovers: imeiDropdownRef, etc.
            if (imeiDropdownRef && imeiDropdownRef.current && imeiDropdownRef.current.contains(target)) return;

            // otherwise close main drawer
            setDrawerOpen(false);
            setSelectedRow(null);
            setSelectedIds(ids => selectedRow ? ids.filter(id => id !== selectedRow.id) : ids);
        }

        document.addEventListener('mousedown', handleClickOutsideDrawer);
        return () => document.removeEventListener('mousedown', handleClickOutsideDrawer);
    }, [drawerOpen, selectedRow]);
    const [stockfilterDrawerOpen, setStockfilterDrawerOpen] = useState(false);
    useEffect(() => {
        function handleClickOutsideFilter(e) {
            if (!stockfilterDrawerOpen) return;
            // if click inside filter drawer, keep it open
            if (filterDrawerRef.current && filterDrawerRef.current.contains(e.target)) return;
            // if click is inside main drawer and you prefer NOT to close filter when user clicks main drawer, return
            if (drawerRef.current && drawerRef.current.contains(e.target)) {
                // decide: either close filter when clicking main drawer or keep it open.
                // I will close the filter when clicking main by default — change to `return;` if you want to keep it open.
                // return;
            }
            // otherwise close filter
            setStockfilterDrawerOpen(false);
        }

        document.addEventListener('mousedown', handleClickOutsideFilter);
        return () => document.removeEventListener('mousedown', handleClickOutsideFilter);
    }, [stockfilterDrawerOpen]);



    // Dropdown positioning state
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !buttonRefs.current[dropdownOpenId]?.contains(event.target)
            ) {
                setDropdownOpenId(null);
            }
        }

        if (dropdownOpenId !== null) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownOpenId]);

    // Toggle the per‐row dropdown menu
    const toggleDropdown = (id) => {
        if (dropdownOpenId === id) {
            setDropdownOpenId(null);
        } else {
            const btn = buttonRefs.current[id];
            if (btn) {
                const rect = btn.getBoundingClientRect();
                const dropdownWidth = 150;
                const dropdownHeight = 100;

                let left = rect.left + window.scrollX - dropdownWidth + rect.width;
                if (left < window.scrollX + 8) {
                    left = window.scrollX + 8;
                }

                let top = rect.bottom + window.scrollY;
                if (top + dropdownHeight > window.scrollY + window.innerHeight) {
                    top = rect.top + window.scrollY - dropdownHeight;
                }

                setDropdownPosition({ top, left });
            }
            setDropdownOpenId(id);
        }
    };
    const archivedRef = useRef(null);
    const [archivedModalOpen, setArchivedModalOpen] = useState(false);
    const handleArchivedConfirm = () => {
        setArchivedModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (archivedRef.current && !archivedRef.current.contains(event.target)) {
                setArchivedModalOpen(false);
            }
        }

        if (archivedModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [archivedModalOpen]);

    // Drawer Dropdown latest code below
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const [toolbarDropdownOpen2, setToolbarDropdownOpen2] = useState(false);
    const toolbarRef = useRef(null);
    const toggleToolbarDropdown = () => {
        setToolbarDropdownOpen(prev => !prev);
    };
    const toggleToolbarDropdown2 = () => {
        setToolbarDropdownOpen2(prev => !prev);
    };
    useEffect(() => {
        setFilterCount(selectedStatuses.length);
    }, [selectedStatuses]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
                setToolbarDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (filterPopupRef.current && !filterPopupRef.current.contains(e.target) &&
                filterButtonRef.current && !filterButtonRef.current.contains(e.target)) {
                setFilterPopupOpen(false);
            }
        };

        if (filterPopupOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [filterPopupOpen]);


    // Drawer -> Stock instances tab table JS
    const [imeiSearchInput, setImeiSearchInput] = useState('');
    const [pageInView, setPageInView] = useState(1); // changed name

    const [isStockOpen, setisStockOpen] = useState(false);
    const [stockSearch, setStockSearch] = useState('');
    const [selectedStock, setSelectedStock] = useState([]);
    const [tempSelectedStock, setTempSelectedStock] = useState([]);
    const stockRef = useRef(null);

    // 1. Filtered & visible rows based on selected branch and global search
    const visibleImeiRows = useMemo(() => {
        let rows = imeiStockData;

        // Filter by selected branch
        if (selectedStock.length > 0) {
            const selectedBranchNames = selectedStock.map(b => b.value);
            rows = rows.filter(row => selectedBranchNames.includes(row.location));
        }

        // Filter by search text
        if (imeiSearchInput.trim()) {
            const searchLower = imeiSearchInput.toLowerCase();
            rows = rows.filter(row =>
                Object.values(row).some(val =>
                    String(val).toLowerCase().includes(searchLower)
                )
            );
        }

        return rows;
    }, [imeiStockData, imeiSearchInput, selectedStock]);

    // 2. Stats (calculated based on visible filtered rows)
    const imeiStats = useMemo(() => {
        let reserved = 0;
        let available = 0;
        const pendingTotals = {};

        visibleImeiRows.forEach(row => {
            reserved += row.reserved || 0;
            available += row.available || 0;

            if (Array.isArray(row.pending)) {
                row.pending.forEach(p => {
                    if (!pendingTotals[p.type]) {
                        pendingTotals[p.type] = { count: 0, color: p.color };
                    }
                    pendingTotals[p.type].count += p.count || 0;
                });
            }
        });

        return { reserved, available, pendingTotals };
    }, [visibleImeiRows]);

    // View Instances Drawer Code
    const [instancesDrawerOpen, setInstancesDrawerOpen] = useState(false);

    // Stock Filter Drawer Code


    // Stock Out modal code
    const stockoutRef = useRef(null);
    const [stockoutModalOpen, setStockoutModalOpen] = useState(false);
    const handleStockoutConfirm = () => {
        setStockoutModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (stockoutRef.current && !stockoutRef.current.contains(event.target)) {
                setStockoutModalOpen(false);
            }
        }

        if (stockoutModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [stockoutModalOpen]);

    //Custom number field arrows input JS
    const [quantity, setQuantity] = useState(1);

    const handleIncrease = () => {
        setQuantity(prev => prev + 1);
    };

    const handleDecrease = () => {
        if (quantity > 1) setQuantity(prev => prev - 1);
    };

    // Stock Instance Drawer table action column dropdown
    const [imeiDropdownOpenId, setImeiDropdownOpenId] = useState(null);
    const tableRef = useRef();
    const imeiDropdownRef = useRef(null);
    const imeiButtonRefs = useRef({});

    // Click outside handler
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tableRef.current && !tableRef.current.contains(e.target)) {
                setImeiDropdownOpenId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Stock Filter Drawer Dropdown code
    const allStock = useMemo(() => {
        const uniqueBranches = [...new Set(imeiStockData.map(item => item.location))];
        return uniqueBranches.map(b => ({ label: b, value: b }));
    }, [imeiStockData]);


    // Toggle dropdown open/closed
    const toggleStock = () => {
        setisStockOpen((prev) => !prev);
    };

    // Close dropdown if clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isStockOpen && stockRef.current && !stockRef.current.contains(e.target)) {
                setisStockOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isStockOpen]);

    // Filtered list based on search text
    const filteredStock = allStock.filter((d) =>
        d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
    );

    // Add/remove stocks from selectedStock
    const handleStockCheckbox = (stocks) => {
        const exists = selectedStock.findIndex((item) => item.value === stocks.value);
        if (exists > -1) {
            // Remove if already selected
            setSelectedStock((prev) => prev.filter((item) => item.value !== stocks.value));
        } else {
            // Otherwise, add
            setSelectedStock((prev) => [...prev, stocks]);
        }
    };

    // Remove a tag when “×” is clicked
    const removeStock = (valueToRemove) => {
        setSelectedStock((prev) =>
            prev.filter((item) => item.value !== valueToRemove)
        );
    };

    const handleTempStockCheckbox = (stock) => {
        setTempSelectedStock((prev) => {
            const exists = prev.find((item) => item.value === stock.value);
            if (exists) {
                return prev.filter((item) => item.value !== stock.value);
            } else {
                return [...prev, stock];
            }
        });
    };

    useEffect(() => {
        if (stockfilterDrawerOpen) {
            setStockSearch(""); // Clear previous search
        }
    }, [stockfilterDrawerOpen]);

    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const handleSaveConfirm = () => {
        setSaveModalOpen(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }

        if (saveModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [saveModalOpen]);

    // near the top with other refs
    const drawerContainerRef = useRef(null);
    const filterDrawerRef = useRef(null);

    // toggle CSS class on parent so main drawer shifts reliably
    useEffect(() => {
        const el = drawerContainerRef.current;
        if (!el) return;
        if (stockfilterDrawerOpen) el.classList.add('filter-open');
        else el.classList.remove('filter-open');

        return () => el && el.classList.remove('filter-open');
    }, [stockfilterDrawerOpen]);
    useEffect(() => {
        if (filterPopupOpen && filterButtonRef.current) {
            const rect = filterButtonRef.current.getBoundingClientRect();
            setFilterPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX
            });
        }
    }, [filterPopupOpen]);
    const handleCheckboxChange = (status) => {
        setSelectedStatuses((prevStatuses) => {
            if (prevStatuses.includes(status)) {
                return prevStatuses.filter((s) => s !== status);
            } else {
                return [...prevStatuses, status];
            }
        });
    };


    return (
        <div className="company-body new-look stock-wrap">
            {/* Breadcrumbs */}
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => (
                    <span key={index} className="breadcrumb-item">
                        {crumb}
                        {index !== breadcrumbs.length - 1}
                    </span>
                ))}
            </div>

            <div className="employee-tabs-container">
                {/* ─── Tab Buttons ─── */}
                <div className="tabs">
                    <button
                        // Apply the "active" class only when this tab is selected
                        className={`tab ${activeTab === 'stock-list' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('stock-list')}
                    >
                        Stock List
                    </button>

                    <button
                        className={`tab ${activeTab === 'archived-stock' ? 'active' : ''
                            }`}
                        onClick={() => setActiveTab('archived-stock')}
                    >
                        Archived Stock
                    </button>
                </div>

                {/* ─── Tab Contents ─── */}
                {activeTab === 'stock-list' && (
                    <div className="tab-content" id="stock-list-content">
                        {/* Stock List Card */}
                        <div className="info-section">
                            <div className="info-card">
                                <div className="info-header">
                                    <h4 className="info-title">Stock List</h4>
                                </div>

                                <div className="entities-tab">
                                    {/* Toolbar: Search + Filter on left; Edit/Plus on right */}
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={searchTerm}
                                                    onChange={e => {
                                                        setSearchTerm(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                            <button
                                                ref={filterButtonRef}
                                                className="icon-btn"
                                                onClick={() => setFilterPopupOpen(!filterPopupOpen)}
                                            >
                                                <Funnel size={18} /> Filter
                                                {filterCount > 0 && (
                                                    <span className="filter-counts"
                                                        style={{
                                                            background: '#000',
                                                            color: '#ffffff',
                                                            borderRadius: '50%',
                                                            width: '16px',
                                                            height: '16px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '12px',
                                                            marginLeft: '5px'
                                                        }}>
                                                        {filterCount}
                                                    </span>
                                                )}
                                            </button>

                                        </div>
                                        <div className="toolbar-right">
                                            <button className="icon-btn"
                                            // onClick={() => history.push("/branches/edit-branch")}
                                            >
                                                <Pencil size={18} /> Bulk Edit
                                            </button>
                                            <button
                                                className="icon-btn dark-border"
                                            // onClick={() => history.push("/branches/add-branch")}
                                            >
                                                <SquareArrowOutUpRight size={18} /> In/Out
                                            </button>
                                        </div>
                                    </div>

                                    {filterPopupOpen && (
                                        <div
                                            ref={filterPopupRef}
                                             className="filter-popup"
                                            style={{
                                                position: 'absolute',
                                                top: filterPosition.top,
                                                left: filterPosition.left,
                                                background: '#fff',
                                                padding: '16px',
                                                borderRadius: '8px',
                                                width: '300px',
                                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                zIndex: '1002',
                                                maxHeight: '350px',
                                                overflowY: 'auto',
                                                scrollbarWidth: 'none',
                                                msOverflowStyle: 'none',
                                            }}
                                           
                                        >
                                            {/* Header with close button */}
                                            <div
                                                className="filter-header"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    marginBottom: '16px',
                                                }}
                                            >
                                                <button className="close-btn" onClick={() => setFilterPopupOpen(false)}>
                                                    <X size={20} />
                                                </button>
                                            </div>

                                            {/* Content */}
                                            <div className="filter-content">
                                                {/* Status Filter */}
                                                <div className="filter-section" style={{ marginBottom: '16px' }}>
                                                    <label style={{ display: 'block', marginBottom: '4px' }}>
                                                        Status
                                                    </label>
                                                    <div
                                                        className="filter-options"
                                                        style={{ maxHeight: '90px', overflowY: 'auto' }}
                                                    >
                                                        {['Active', 'Inactive'].map((status) => (
                                                            <label
                                                                key={status}
                                                                className="form-check"
                                                                style={{ cursor: 'pointer', fontWeight: '400' }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedStatuses.includes(status)}
                                                                    onChange={() => handleCheckboxChange(status)}
                                                                />
                                                                <span style={{ marginLeft: '8px' }}>{status}</span>
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}



                                    {/* Table */}
                                    <div className="table-wrapper">
                                        <table className="entities-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                    selectedIds.length === pageData.length && pageData.length > 0
                                                                }
                                                                onChange={toggleAll}
                                                            />
                                                        </div>
                                                    </th>
                                                    <th onClick={() => handleSort('spu_name')}>
                                                        <span>
                                                            SPU & SKU <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('brand_name')}>
                                                        <span>
                                                            Condition <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('spu_status_text')}>
                                                        <span>
                                                            Status <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('stock_instance_id')}>
                                                        <span>
                                                            ID <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('brand_name')}>
                                                        <span>
                                                            Brand <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('category_name')}>
                                                        <span>
                                                            Category <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('is_reserved')}>
                                                        <span>
                                                            Reserved <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('stock_quantity')}>
                                                        <span>
                                                            Available <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th onClick={() => handleSort('brand_name')}>
                                                        <span>
                                                            Pending <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th className="sticky-action-col" style={{ textAlign: 'center' }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pageData.map((row, idx) => {
                                                    const isRowSelected =
                                                        (selectedIds.includes(row.id) || dropdownOpenId === row.id) && !suppressHighlight;
                                                    console.log('this is row data', row);

                                                    return (
                                                        <tr
                                                            key={row.id}
                                                            className={[
                                                                idx % 2 ? 'striped' : '',
                                                                isRowSelected ? 'row-selected' : ''
                                                            ].join(' ')}
                                                            onClick={() => onRowClick(row)}
                                                        >
                                                            <td>
                                                                <div className="form-check" onClick={e => e.stopPropagation()}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedIds.includes(row.id)}
                                                                        onChange={e => {
                                                                            toggleSelect(row.id);
                                                                            if (e.target.checked) {
                                                                                setSelectedRow(row);
                                                                            } else if (selectedRow?.id === row.id) {
                                                                                setSelectedRow(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="name-cell" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                    <img
                                                                        src={row.avatar}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{
                                                                            width: 28,
                                                                            height: 28,
                                                                            marginRight: 8,
                                                                            verticalAlign: 'middle'
                                                                        }}
                                                                    />
                                                                    <div>
                                                                        <div>{row?.spu_name}</div>
                                                                        <div className="sub-line">{row?.variant}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {/* <div className="condition-wrapper">
                                                                    <span className={`status ${row?.condition.toLowerCase()}`}>{row?.condition}</span>
                                                                    <span className={`status ${row?.grading.toLowerCase()}`}>{row?.grading}</span>
                                                                </div> */}
                                                            </td>
                                                            <td>
                                                             {/*
                                                                <span className={`status ${row.spu_status_text.toLowerCase()}`}>
                                                                    {row.spu_status_text}
                                                                </span>
                                                                 */}

                                                            </td>
                                                            <td>{row?.stock_instance_id}</td>
                                                            <td>
                                                                {row?.brand_name}
                                                            </td>
                                                            <td>{row?.category_name}</td>
                                                            <td>{row?.is_reserved ? "Yes" : "No"}</td>
                                                            <td>{row?.stock_quantity}</td>

                                                            <td>
                                                                {/* <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                    {row.pending.map((p, i) => (
                                                                        <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                            <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                            <span style={{ color: "#6C757D", marginRight: 4 }}>{p.type}</span>
                                                                            <span style={{ marginLeft: "auto", marginRight: "8px" }}>{p.count}</span>
                                                                        </div>
                                                                    ))}
                                                                </div> */}
                                                            </td>

                                                            <td className="sticky-action-col" style={{ textAlign: "center", position: "relative" }}>
                                                                <button
                                                                    ref={el => (buttonRefs.current[row.id] = el)}
                                                                    className="icon-btn"
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        toggleDropdown(row.id);
                                                                    }}
                                                                >
                                                                    <MoreHorizontal size={20} />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}

                                                {/* If there are fewer rows than PAGE_SIZE, fill out empty rows
                      so that clicking these “tr.s” does nothing (no highlight, no drawer). */}
                                                {pageData.length < PAGE_SIZE && (
                                                    [...Array(PAGE_SIZE - pageData.length)].map((_, idx) => (
                                                        <tr
                                                            key={`empty-${idx}`}
                                                            className="empty-row"
                                                            onClick={() => {
                                                                /* Click on empty row: do nothing. */
                                                            }}
                                                        >
                                                            <td colSpan={11}>&nbsp;</td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>

                                        {/* Per‐row dropdown menu */}
                                        {dropdownOpenId !== null && (
                                            <div
                                                ref={dropdownRef}
                                                className="backdrop-cls"
                                                style={{
                                                    position: "absolute",
                                                    top: dropdownPosition.top,
                                                    left: dropdownPosition.left,
                                                    background: "white",
                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                    zIndex: 1000,
                                                    minWidth: 152,
                                                    borderRadius: 8,
                                                }}
                                                onClick={e => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                alert("View Details clicked");
                                                                setDropdownOpenId(null); // 👈 Close dropdown
                                                            }}
                                                        >
                                                            View Details
                                                        </button>
                                                    </div>

                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                setSaveModalOpen(true);
                                                                setDropdownOpenId(null); // 👈 Close dropdown
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>

                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                alert("Deactivate clicked");
                                                                setDropdownOpenId(null); // 👈 Close dropdown
                                                            }}
                                                        >
                                                            Deactivate
                                                        </button>
                                                    </div>

                                                    <div className="common-for-all">
                                                        <button
                                                            onClick={() => {
                                                                // setArchivedModalOpen(true);
                                                                setDropdownOpenId(null); // 👈 Close dropdown
                                                            }}
                                                            className="deactivate-cls"
                                                        >
                                                            Archive
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Pagination */}
                                    {/* {filtered.length > PAGE_SIZE && ( */}
                                    <div className="pagination">
                                        <div className="pagination-info">
                                            {`Showing ${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(currentPage * PAGE_SIZE, filtered.length)} of ${filtered.length} items`}
                                        </div>
                                        <div className="pagination-controls">
                                            <button
                                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                                disabled={currentPage === 1}
                                            >
                                                <ChevronLeft size={20} />
                                            </button>
                                            {[...Array(totalPages)].map((_, i) => (
                                                <button
                                                    key={i}
                                                    className={currentPage === i + 1 ? 'active' : ''}
                                                    onClick={() => setCurrentPage(i + 1)}
                                                >
                                                    {i + 1}
                                                </button>
                                            ))}
                                            <button
                                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                                disabled={currentPage === totalPages}
                                            >
                                                <ChevronRight size={20} />
                                            </button>
                                        </div>
                                    </div>
                                    {/* )} */}
                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="drawer-container" ref={drawerContainerRef}>
                            {/* Single‐row Drawer (unchanged) */}
                            {drawerOpen && selectedRow && (() => {
                                const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                                const total = Number(selectedRow.available || 0) + pendingCount;
                                return (
                                    <>
                                        <div className="drawer-overlay main-drawer-overlay" />
                                        <div className="entity-drawer" ref={drawerRef}>
                                            <div className="drawer-header">
                                                <h3>Stock Info</h3>
                                                <button
                                                    className="close-btn"
                                                    onClick={() => {
                                                        setDrawerOpen(false);
                                                        setSelectedIds(ids => ids.filter(id => id !== selectedRow?.id));
                                                        setSelectedRow(null);
                                                    }}
                                                >
                                                    <X size={24} />
                                                </button>
                                            </div>
                                            <div className="main-drawer-inner">
                                                <div className="drawer-title d-flex align-items-center justify-content-between">
                                                    <div className='d-flex align-items-center'>
                                                        <img
                                                            src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                                                            alt="avatar"
                                                            className="avatar"
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                marginRight: 8,
                                                                verticalAlign: 'middle'
                                                            }}
                                                        />
                                                        <h2 className='pb-0'>{selectedRow?.name}</h2>
                                                    </div>
                                                    <div className='entities-tab flex-row align-items-center gap-3'>
                                                        <div class="main-company-body-inner">
                                                            <div class="edit-organisation-info d-flex justify-content-end align-items-center gap-2 p-0">
                                                                <button class="dark-border gray-btn" type="button"
                                                                    onClick={() => setSaveModalOpen(true)}>Edit</button>
                                                            </div>
                                                        </div>
                                                        <div className='toolbar'>
                                                            <div className="toolbar-right" style={{ position: "relative" }} ref={toolbarRef}>
                                                                <button
                                                                    className="drawer-dots"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleToolbarDropdown();
                                                                    }}
                                                                >
                                                                    <MoreHorizontal size={18} />
                                                                </button>

                                                                {toolbarDropdownOpen && (
                                                                    <div
                                                                        className="backdrop-cls"
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: 40,
                                                                            right: 0,
                                                                            background: "white",
                                                                            boxShadow: "0px 1px 4px 0px #0000001A",
                                                                            zIndex: 1000,
                                                                            minWidth: 152,
                                                                            borderRadius: 8,
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <div className="btn-align-forall">
                                                                            <div className="common-for-all">
                                                                                <button onClick={() => {
                                                                                    setInstancesDrawerOpen(true);
                                                                                    setDrawerOpen(false);
                                                                                }}>View Instances</button>
                                                                            </div>
                                                                            <div className="common-for-all">
                                                                                <button onClick={() => alert("Deactivate clicked")}>Deactivate</button>
                                                                            </div>
                                                                            <div className="common-for-all">
                                                                                <button className="deactivate-cls">
                                                                                    Archive
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="drawer-tabs">
                                                    <button
                                                        className={drawerTab === 'entity-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('entity-info')}
                                                    >
                                                        Product Info
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'stock-instances' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('stock-instances')}
                                                    >
                                                        Stock Instances
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'additional-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('additional-info')}
                                                    >
                                                        Additional Info
                                                    </button>
                                                </div>

                                                <div className="drawer-content">
                                                    {drawerTab === 'entity-info' && (
                                                        <div className="tab-panel entity-info-panel">
                                                            <div className="field-block">
                                                                <div className="field-label">SPU & SKU</div>
                                                                <div className="field-value" style={{ marginBottom: '10px' }}>{selectedRow.name}</div>
                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    <span style={{ fontWeight: 600 }}>Color:</span> {selectedRow.variant?.split(',')[0] || '-'}
                                                                </div>
                                                                <div className="field-value" style={{ gap: '4px' }}>
                                                                    <span style={{ fontWeight: 600 }}>Storage:</span> {selectedRow.variant?.split(',')[1]?.trim() || '-'}
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Condition</div>
                                                                <div className="field-value gap-2">
                                                                    <span className={`status ${selectedRow.condition.toLowerCase()}`}>
                                                                        {selectedRow.condition}
                                                                    </span>
                                                                    <span className={`status ${selectedRow.grading.toLowerCase()}`}>
                                                                        {selectedRow.grading}
                                                                    </span>
                                                                </div>
                                                                {/* <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                <span style={{ fontWeight: 600 }}>Activation Status:</span> {selectedRow.grading}
                                                            </div>
                                                            <div className="field-value" style={{ gap: '4px' }}>
                                                                <span style={{ fontWeight: 600 }}>Condition Grade:</span> {selectedRow.condition}
                                                            </div> */}
                                                            </div>


                                                            <div className="field-block">
                                                                <div className="field-label">Open ID</div>
                                                                <div className="field-value d-flex align-items-center gap-2">
                                                                    <span style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")}>
                                                                        8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                                                    </span>
                                                                    <Copy size={13} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")} style={{ cursor: "pointer", color: "#2C7BE5" }} />
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Status</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${selectedRow.status.toLowerCase()}`}>
                                                                        {selectedRow.status}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">ID</div>
                                                                <div className="field-value">{selectedRow.iD}</div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Brand</div>
                                                                <div className="field-value">
                                                                    {selectedRow.brand}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Category</div>
                                                                <div className="field-value">
                                                                    Smart Device &gt; {selectedRow.category}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Reserved</div>
                                                                <div className="field-value">
                                                                    {selectedRow.reserved}
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Quantity</div>

                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    Total: {total}
                                                                </div>

                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    Available: {selectedRow.available}
                                                                </div>

                                                                <div className="field-value" style={{ gap: '4px' }}>
                                                                    Pending: {pendingCount}
                                                                </div>

                                                                <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: '150px' }}>
                                                                        {selectedRow.pending?.map((p, i) => (
                                                                            <div
                                                                                key={i}
                                                                                className='field-value'
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                }}
                                                                            >
                                                                                <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                <span style={{ marginRight: 4 }}>{p.type}</span>
                                                                                <span style={{ marginLeft: 'auto', marginRight: '8px' }}>{p.count}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'stock-instances' && (
                                                        <div className="tab-panel stock-instances-panel">
                                                            <div className='entities-tab' style={{ padding: 0, paddingTop: '20px' }}>
                                                                <div className="toolbar">
                                                                    <div className="toolbar-left">
                                                                        <div className="search-box">
                                                                            <Search size={20} />
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Search…"
                                                                                value={imeiSearchInput}
                                                                                onChange={e => {
                                                                                    setImeiSearchInput(e.target.value);
                                                                                    setPageInView(1); // reset pagination if needed
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <button className="icon-btn" onClick={() => {
                                                                            setTempSelectedStock(selectedStock);
                                                                            setStockfilterDrawerOpen(true);
                                                                        }}>
                                                                            <Funnel size={18} /> Filter
                                                                            {selectedStock.length > 0 && (
                                                                                <span style={{
                                                                                    background: '#212529',
                                                                                    color: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    fontSize: '12px',
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginLeft: 6
                                                                                }}>
                                                                                    {selectedStock.length}
                                                                                </span>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div className='row gy-3 gy-md-0'>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Reserved</p>
                                                                            <h6 style={{ fontSize: 28, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal', marginBottom: 0, marginTop: 'auto' }}>{imeiStats.reserved}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Available</p>
                                                                            <h6 style={{ fontSize: 28, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal', marginBottom: 0, marginTop: 'auto' }}>{imeiStats.available}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Pending</p>
                                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                                {Object.entries(imeiStats.pendingTotals).map(([type, data]) => (
                                                                                    <div key={type} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                                        <span style={{ color: data.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                        <span style={{ color: "#6C757D", marginRight: 8 }}>{type}</span>
                                                                                        <span style={{ marginLeft: "auto", color: '#212529' }}>{data.count}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='table-wrapper'>
                                                                    <table className="entities-table" ref={tableRef} style={{ minWidth: "unset" }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th><span>IMEI/Barcode <ChevronsUpDown size={10} /></span></th>
                                                                                <th><span>Branch <ChevronsUpDown size={10} /></span></th>
                                                                                <th>
                                                                                    <span>
                                                                                        Reserved <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th>
                                                                                    <span>
                                                                                        Available <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th>
                                                                                    <span>
                                                                                        Pending <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th className="sticky-action-col" style={{ textAlign: 'center' }}>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {visibleImeiRows.map((item, idx) => (
                                                                                <tr key={idx} className={idx % 2 === 1 ? 'striped' : ''}>
                                                                                    <td className='py-3'>
                                                                                        <a
                                                                                            href="#"
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            className="d-flex align-items-center gap-1 me-3"
                                                                                            style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px' }}
                                                                                        >
                                                                                            {item.imei}
                                                                                            <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                                        </a>
                                                                                    </td>
                                                                                    <td className='py-3'>{item.location}</td>
                                                                                    <td>{item.reserved}</td>
                                                                                    <td>{item.available}</td>
                                                                                    <td>
                                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                                            {item.pending.map((p, i) => (
                                                                                                <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                                                    <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                                    <span style={{ color: "#6C757D", marginRight: 8 }}>{p.type}</span>
                                                                                                    <span style={{ marginLeft: "auto", marginRight: "8px" }}>{p.count}</span>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </td>

                                                                                    <td className="sticky-action-col" style={{ textAlign: "center", position: "relative" }}>
                                                                                        <button
                                                                                            className="icon-btn"
                                                                                            onClick={e => {
                                                                                                e.stopPropagation();
                                                                                                setImeiDropdownOpenId(prevId => (prevId === item.id ? null : item.id));
                                                                                            }}
                                                                                        >
                                                                                            <MoreHorizontal size={20} />
                                                                                        </button>

                                                                                        {imeiDropdownOpenId === item.id && (
                                                                                            <div
                                                                                                className="backdrop-cls"
                                                                                                style={{
                                                                                                    position: "absolute",
                                                                                                    top: "40px",
                                                                                                    right: "0",
                                                                                                    background: "white",
                                                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                                                    zIndex: 1000,
                                                                                                    minWidth: 152,
                                                                                                    borderRadius: 8,
                                                                                                }}
                                                                                                onClick={e => e.stopPropagation()}
                                                                                            >
                                                                                                <div className="btn-align-forall">
                                                                                                    <div className="common-for-all">
                                                                                                        <button className="deactivate-cls">Stock Out</button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </td>

                                                                                </tr>
                                                                            ))}
                                                                            {visibleImeiRows.length === 0 && (
                                                                                <tr>
                                                                                    <td colSpan="5" className="py-3 text-center">No results found.</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'additional-info' && (
                                                        <div className="tab-panel additional-info-panel">
                                                            <p className="note-type-added">Note</p>
                                                            <label className="no-description-cls">No Description</label>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                );

                            })()}

                            {stockfilterDrawerOpen && (() => {

                                return (

                                    <>
                                        <div
                                            className="drawer-overlay filter-drawer-overlay"
                                            onMouseDown={(e) => {
                                                // stop event from reaching document click handlers (so main drawer doesn't close)
                                                e.stopPropagation();
                                                setStockfilterDrawerOpen(false); // clicking overlay closes only the filter drawer
                                            }}
                                        />

                                        <div className="filter-drawer" ref={filterDrawerRef}>
                                            <div className="drawer-header">
                                                <div className="d-flex align-items-center gap-1">
                                                    <h3>Filter</h3>
                                                </div>

                                                <button
                                                    className="close-btn"
                                                    onClick={() => {
                                                        setStockfilterDrawerOpen(false); // just close the filter drawer, leave main drawer as-is
                                                    }}
                                                >
                                                    <X size={24} />
                                                </button>
                                            </div>
                                            <div className='main-company-body-inner d-flex flex-column h-100'>
                                                <div className="main-drawer-inner">
                                                    {/* ─── ROW 1: Branch ─────────────────────────────────────── */}
                                                    <div className='row gappingcls-added'>
                                                        <div className='col-12'>
                                                            <div
                                                                className="info-inner"
                                                                ref={stockRef}
                                                                style={{ position: 'relative' }}
                                                            >
                                                                <label className="form-label d-flex align-items-center gap-2">
                                                                    Branch
                                                                </label>

                                                                {/* CLOSED VIEW: tags + arrow */}
                                                                <div
                                                                    className="select-box form-control common-input-all"
                                                                    onClick={toggleStock}
                                                                    style={{
                                                                        padding: '0.5rem',
                                                                        minHeight: '40px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        flexWrap: 'wrap',
                                                                        position: 'relative',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {tempSelectedStock.length > 0 ? (
                                                                        tempSelectedStock.map((d) => (
                                                                            <span
                                                                                key={d.value}
                                                                                className="tag"
                                                                                style={{
                                                                                    backgroundColor: '#FFEB00',
                                                                                    color: '#212529',
                                                                                    borderRadius: '16px',
                                                                                    padding: '4px 8px',
                                                                                    margin: '2px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: '600',
                                                                                    lineHeight: 'normal',
                                                                                }}
                                                                            >
                                                                                {d.label}
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setTempSelectedStock((prev) =>
                                                                                            prev.filter((item) => item.value !== d.value)
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        background: 'none',
                                                                                        border: 'none',
                                                                                        marginLeft: '20px',
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '16px',
                                                                                        padding: '0',
                                                                                        lineHeight: '14px',
                                                                                    }}
                                                                                >
                                                                                    <X size={14} strokeWidth={3} />
                                                                                </button>
                                                                            </span>
                                                                        ))
                                                                    ) : (
                                                                        <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                                            Select Branch
                                                                        </span>
                                                                    )}

                                                                    {/* Selected count */}
                                                                    <span
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginLeft: 'auto',
                                                                            gap: '0.25rem',
                                                                            fontSize: '0.8rem',
                                                                            color: '#666',
                                                                        }}
                                                                    >
                                                                        <ChevronDown
                                                                            size={16}
                                                                            style={{
                                                                                transform: isStockOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                                transition: 'transform 0.2s',
                                                                                userSelect: 'none',
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>

                                                                {/* DROPDOWN PANEL (visible when isStockOpen) */}
                                                                {isStockOpen && (
                                                                    <div
                                                                        className="options-container"
                                                                        style={{
                                                                            border: '1px solid #6c757d',
                                                                            borderRadius: '8px',
                                                                            marginTop: '4px',
                                                                            maxHeight: '270px',
                                                                            overflowY: 'auto',
                                                                            background: '#fff',
                                                                            position: 'absolute',
                                                                            top: '100%',
                                                                            left: 0,
                                                                            zIndex: 1000,
                                                                            width: '100%',
                                                                            boxshadow: '0px 1px 4px 0px #0000001A',
                                                                        }}
                                                                        onWheel={(e) => e.preventDefault()}
                                                                    >
                                                                        {/* Search input with icon */}
                                                                        <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                                            <Search
                                                                                size={18}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '50%',
                                                                                    left: '18px',
                                                                                    transform: 'translateY(-50%)',
                                                                                    color: '#6C757D',
                                                                                    pointerEvents: 'none',
                                                                                }}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="search-input select-box form-control common-input-all"
                                                                                placeholder="Search..."
                                                                                value={stockSearch}
                                                                                onChange={(e) => setStockSearch(e.target.value)}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                                    fontSize: '0.9rem',
                                                                                    outline: 'none',
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        {/* Options list */}
                                                                        <ul
                                                                            className="options-list custom-check"
                                                                            style={{
                                                                                listStyle: 'none',
                                                                                margin: 0,
                                                                                padding: '1.25rem',
                                                                                maxHeight: '420px',
                                                                                overflowY: 'auto',
                                                                            }}
                                                                        >
                                                                            {[...new Set(
                                                                                [
                                                                                    ...allStock.filter((d) =>
                                                                                        d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
                                                                                    ),
                                                                                    ...tempSelectedStock.filter(
                                                                                        (s) => !allStock.some((d) => d.value === s.value)
                                                                                    ),
                                                                                ]
                                                                            )].map((d) => (
                                                                                <li key={d.value} style={{ marginBottom: '0.5rem' }}>
                                                                                    <label
                                                                                        className="option-item"
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            cursor: 'pointer',
                                                                                            fontSize: '0.9rem',
                                                                                            fontWeight: 'normal',
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            checked={tempSelectedStock.some((item) => item.value === d.value)}
                                                                                            onChange={() => handleTempStockCheckbox(d)}
                                                                                            style={{ marginRight: '8px' }}
                                                                                        />
                                                                                        {d.label}
                                                                                    </label>
                                                                                </li>
                                                                            ))}

                                                                            {allStock.filter((d) =>
                                                                                d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
                                                                            ).length === 0 && tempSelectedStock.length === 0 && (
                                                                                    <li
                                                                                        style={{
                                                                                            color: '#999',
                                                                                            textAlign: 'center',
                                                                                            fontSize: '0.9rem',
                                                                                        }}
                                                                                    >
                                                                                        No branch found
                                                                                    </li>
                                                                                )}
                                                                        </ul>


                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mt-auto main-drawer-inner'>
                                                    <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2 mt-auto'>
                                                        <button
                                                            className="dark-button"
                                                            type="button"
                                                            onClick={() => {
                                                                setStockfilterDrawerOpen(false);
                                                                setTempSelectedStock(selectedStock); // discard any changes, keep main drawer visible
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>

                                                        <button
                                                            className="dark-border"
                                                            type="button"
                                                            onClick={() => {
                                                                setSelectedStock(tempSelectedStock); // apply the filter
                                                                setStockfilterDrawerOpen(false); // close only the filter drawer
                                                            }}
                                                        >
                                                            Filter
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                );
                            })()}
                        </div>


                        {instancesDrawerOpen && selectedRow && (() => {
                            // Safely compute values here
                            const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                            const total = Number(selectedRow.available || 0) + pendingCount;

                            return (

                                <>
                                    <div className="drawer-overlay" />
                                    <div className="entity-drawer" ref={drawerRef}>
                                        <div className="drawer-header">
                                            <div className="d-flex align-items-center gap-1">
                                                <button
                                                    className="back-btn"
                                                    onClick={() => {
                                                        setInstancesDrawerOpen(false);
                                                        setDrawerOpen(true);
                                                    }}
                                                    style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                                >
                                                    <ChevronLeft />
                                                </button>
                                                <h3>Stock Instance Info</h3>
                                            </div>

                                            <button
                                                className="close-btn"
                                                onClick={() => {
                                                    setInstancesDrawerOpen(false);
                                                }}
                                            >
                                                <X size={24} />
                                            </button>
                                        </div>

                                        <div className="main-drawer-inner">
                                            <div className="drawer-title d-flex align-items-center justify-content-between">
                                                <div className='d-flex align-items-center'>
                                                    <img
                                                        src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                                                        alt="avatar"
                                                        className="avatar"
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            marginRight: 8,
                                                            verticalAlign: 'middle'
                                                        }}
                                                    />
                                                    <h2 className='pb-0'>35334107 123456 2</h2>
                                                </div>
                                                <div className='entities-tab flex-row align-items-center gap-3'>
                                                    <div className='toolbar'>
                                                        <div className="toolbar-right" style={{ position: "relative" }} ref={toolbarRef}>
                                                            <button
                                                                className="drawer-dots"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleToolbarDropdown2();
                                                                }}
                                                            >
                                                                <MoreHorizontal size={18} />
                                                            </button>

                                                            {toolbarDropdownOpen2 && (
                                                                <div
                                                                    className="backdrop-cls"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: 40,
                                                                        right: 0,
                                                                        background: "white",
                                                                        boxShadow: "0px 1px 4px 0px #0000001A",
                                                                        zIndex: 1000,
                                                                        minWidth: 152,
                                                                        borderRadius: 8,
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <div className="btn-align-forall">
                                                                        <div className="common-for-all">
                                                                            <button onClick={() => {
                                                                                setStockoutModalOpen(true);
                                                                            }}>Stock Out</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                            <div className="drawer-tabs">
                                                <button
                                                    className={drawerTab2 === 'entity-info2' ? 'active' : ''}
                                                    onClick={() => setDrawerTab2('entity-info2')}
                                                >
                                                    Stock Info
                                                </button>
                                                <button
                                                    className={drawerTab2 === 'additional-info' ? 'active' : ''}
                                                    onClick={() => setDrawerTab2('additional-info')}
                                                >
                                                    Additional Info
                                                </button>
                                            </div>

                                            <div className="drawer-content">
                                                {drawerTab2 === 'entity-info2' && (
                                                    <div className="tab-panel entity-info-panel">
                                                        <div className="field-block">
                                                            <div className="field-label">IMEI/Barcode</div>
                                                            <div className="field-value">35334107 123456 2</div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Open ID</div>
                                                            <div className="field-value d-flex align-items-center gap-2">
                                                                <span style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")}>
                                                                    8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                                                </span>
                                                                <Copy size={13} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")} style={{ cursor: "pointer", color: "#2C7BE5" }} />
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Status</div>
                                                            <div className="field-value">
                                                                <span className={`status ${selectedRow.status.toLowerCase()}`}>
                                                                    {selectedRow.status}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">ID</div>
                                                            <div className="field-value">{selectedRow.iD}</div>
                                                        </div>
                                                        <div className="field-block">
                                                            <div className="field-label">Branch</div>
                                                            <div className="field-value">
                                                                <a
                                                                    href="#"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="d-flex align-items-center gap-1 me-3"
                                                                    style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px' }}
                                                                >
                                                                    Bedok
                                                                    <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="field-block">
                                                            <div className="field-label">Reserved</div>
                                                            <div className="field-value">
                                                                {selectedRow.reserved}
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Quantity</div>

                                                            <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                Total: {total}
                                                            </div>

                                                            <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                Available: {selectedRow.available}
                                                            </div>

                                                            <div className="field-value" style={{ gap: '4px' }}>
                                                                Pending: {pendingCount}
                                                            </div>

                                                            <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: '150px' }}>
                                                                    {selectedRow.pending?.map((p, i) => (
                                                                        <div
                                                                            key={i}
                                                                            className='field-value'
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                            }}
                                                                        >
                                                                            <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                            <span style={{ marginRight: 4 }}>{p.type}</span>
                                                                            <span style={{ marginLeft: 'auto', marginRight: '8px' }}>{p.count}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">First Stock In Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">First Stock In Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock In Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock In Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock Out Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock Out Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {drawerTab2 === 'additional-info' && (
                                                    <div className="tab-panel additional-info-panel">
                                                        <p className="note-type-added">Note</p>
                                                        <label className="no-description-cls">No Description</label>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </>
                            );
                        })()}

                        {stockoutModalOpen && (
                            <>
                                {/* Overlay backdrop */}
                                <div className="drawer-overlay" />

                                <div className="entity-drawer modal-popup-cls" ref={stockoutRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}>
                                    {/* Header */}
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setStockoutModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>

                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Initiate Stock Out</h3>
                                    {/* Subtext */}
                                    <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
                                        Initiating a stock-out means marking the item as no longer part of active inventory. This action only applies to cases such as loss, scrap, or other non-sale or gift removals.
                                    </p>

                                    {/* Form Content */}
                                    <div className="drawer-content">
                                        <div className="row gappingcls-added">
                                            <div className="col-12">
                                                <div className="info-inner tab-panel">
                                                    <div className='field-block'>
                                                        <div className='field-label' style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                            Stock Out <span className="error-color" style={{ color: "red" }}>*</span>
                                                            <Tooltip content="Choose Stock Out">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>
                                                        <select className="form-select new-form-select-cls">
                                                            <option value="">Select Stock Out</option>
                                                            <option value="Loss">Loss</option>
                                                            <option value="Out">Out</option>
                                                        </select>
                                                    </div>
                                                    <div className="field-block">
                                                        <div
                                                            className="field-label"
                                                            style={{ display: 'flex', gap: '4px', alignItems: 'center' }}
                                                        >
                                                            Quantity <span className="error-color" style={{ color: 'red' }}>*</span>
                                                            <Tooltip content="Choose Quantity">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>

                                                        <div className="custom-quantity-wrapper">
                                                            <input
                                                                type="number"
                                                                value={quantity}
                                                                onChange={(e) => setQuantity(Number(e.target.value))}
                                                                className="custom-quantity-input"
                                                            />
                                                            <div className="custom-spinner">
                                                                <ChevronUp size={16} onClick={handleIncrease} className="spinner-icon" />
                                                                <ChevronDown size={16} onClick={handleDecrease} className="spinner-icon" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='field-block'>
                                                        <div className='field-label' style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                            Reason <span className="error-color" style={{ color: "red" }}>*</span>
                                                            <Tooltip content="Choose Reason">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>
                                                        <textarea
                                                            className="form-control w-100 common-textarea-all"
                                                            id="exampleFormControlTextarea1"
                                                            rows="3"
                                                            name="Reason"
                                                            style={{
                                                                borderColor: '#6c757d',
                                                                borderRadius: '8px',
                                                                resize: 'none',
                                                                height: '120px',
                                                                overflowY: 'auto',
                                                                fontFamily: '"Montserrat", sans-serif',
                                                                color: '#6c757d',
                                                                fontSize: '14px',
                                                                fontWeight: 400,
                                                                lineHeight: '18px',
                                                                boxShadow: 'none',
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-cancel" onClick={() => setStockoutModalOpen(false)}>
                                            Cancel
                                        </button>
                                        <button className="btn-save" onClick={handleStockoutConfirm}>
                                            Stock Out
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {archivedModalOpen && (
                            <>
                                {/* Overlay backdrop */}
                                <div className="drawer-overlay" />

                                <div className="entity-drawer modal-popup-cls" ref={archivedRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}>
                                    {/* Header */}
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>

                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Branch can’t be archived</h3>
                                    {/* Subtext */}
                                    <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
                                        Branch stocked with items can’t be archived, clear stock before archiving. Archive action is also subject to approval
                                    </p>

                                    {/* Footer */}
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={handleArchivedConfirm}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>
                )}

                {activeTab === 'archived-stock' && (
                    <div className="tab-content" id="archived-stock-content">
                        {/* Archived Stock Card */}
                        <div className="info-section">
                            <div className="info-card">
                                <div className="info-header">
                                    <h4 className="info-title">Archived Stock</h4>
                                </div>

                                <div className="entities-tab">
                                    <div className="toolbar">
                                        <div className="toolbar-left">
                                            <div className="search-box">
                                                <Search size={20} />
                                                <input
                                                    type="text"
                                                    placeholder="Search…"
                                                    value={archivedSearchTerm}
                                                    onChange={e => {
                                                        setArchivedSearchTerm(e.target.value);
                                                        setArchivedCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                            <button className="icon-btn">
                                                <Funnel size={18} /> Filter
                                            </button>
                                        </div>
                                    </div>

                                    <div className="table-wrapper">
                                        <table className="entities-table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div
                                                            className="form-check"
                                                            onClick={e => e.stopPropagation()}
                                                            onMouseDown={e => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                            />
                                                        </div>
                                                    </th>

                                                    <th>
                                                        <span>
                                                            SPU & SKU <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Condition <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            ID <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Brand <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Category <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Reserved <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Available <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                    <th>
                                                        <span>
                                                            Pending <ChevronsUpDown size={12} />
                                                        </span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {archivedPageData.map((row, idx) => {
                                                    const isRowSelected = archivedSelectedIds.includes(row.id) && !suppressHighlight;

                                                    return (
                                                        <tr
                                                            key={row.id}
                                                            className={[
                                                                idx % 2 ? 'striped' : '',
                                                                isRowSelected ? 'row-selected' : ''
                                                            ].join(' ')}
                                                            onClick={() => onRowClick(row)}
                                                        >
                                                            <td>
                                                                <div
                                                                    className="form-check"
                                                                    onClick={e => e.stopPropagation()} // prevents tr.onClick
                                                                    onMouseDown={e => e.stopPropagation()} // prevents some browsers from firing tr events
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="name-cell" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                    <img
                                                                        src={row.avatar}
                                                                        alt="avatar"
                                                                        className="avatar"
                                                                        style={{
                                                                            width: 28,
                                                                            height: 28,
                                                                            marginRight: 8,
                                                                            verticalAlign: 'middle'
                                                                        }}
                                                                    />
                                                                    <div>
                                                                        <div>{row.name}</div>
                                                                        <div className="sub-line">{row.variant}</div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="condition-wrapper">
                                                                    <span className={`status ${row.condition.toLowerCase()}`}>{row.condition}</span>
                                                                    <span className={`status ${row.grading.toLowerCase()}`}>{row.grading}</span>
                                                                </div>
                                                            </td>
                                                            <td>{row.iD}</td>
                                                            <td>
                                                                {row.brand}
                                                            </td>
                                                            <td>{row.category}</td>
                                                            <td>{row.reserved}</td>
                                                            <td>{row.available}</td>
                                                            <td>
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                    {row.pending.map((p, i) => (
                                                                        <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                            <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                            <span style={{ color: "#6C757D", marginRight: 4 }}>{p.type}</span>
                                                                            <span style={{ marginLeft: "auto", marginRight: "8px" }}>{p.count}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    );
                                                })}

                                                {archivedPageData.length < PAGE_SIZE &&
                                                    [...Array(PAGE_SIZE - archivedPageData.length)].map((_, idx) => (
                                                        <tr key={`empty-off-${idx}`} className="empty-row">
                                                            <td colSpan={11}>&nbsp;</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {archivedFiltered.length > PAGE_SIZE && (
                                        <div className="pagination">
                                            <div className="pagination-info">
                                                {`Showing ${(archivedCurrentPage - 1) * PAGE_SIZE + 1} - ${Math.min(archivedCurrentPage * PAGE_SIZE, archivedFiltered.length)} of ${archivedFiltered.length} items`}
                                            </div>
                                            <div className="pagination-controls">
                                                <button
                                                    onClick={() => setArchivedCurrentPage(p => Math.max(1, p - 1))}
                                                    disabled={archivedCurrentPage === 1}
                                                >
                                                    <ChevronLeft size={20} />
                                                </button>
                                                {[...Array(archivedTotalPages)].map((_, i) => (
                                                    <button
                                                        key={i}
                                                        className={archivedCurrentPage === i + 1 ? 'active' : ''}
                                                        onClick={() => setArchivedCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setArchivedCurrentPage(p => Math.min(archivedTotalPages, p + 1))}
                                                    disabled={archivedCurrentPage === archivedTotalPages}
                                                >
                                                    <ChevronRight size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {saveModalOpen && (
                                        <>
                                            <div className="drawer-overlay" />
                                            <div
                                                className="entity-drawer modal-popup-cls"
                                                ref={saveRef}
                                                style={{
                                                    maxWidth: 650,
                                                    margin: "0 auto",
                                                    background: "white",
                                                    borderRadius: 12,
                                                    zIndex: 1050,
                                                    padding: 24,
                                                    position: "fixed",
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                                    height: "auto",
                                                    right: "auto",
                                                    overflow: "inherit",
                                                }}
                                            >
                                                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                                    <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                                        <X size={20} />
                                                    </button>
                                                </div>
                                                <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>New feature in Progress</h3>
                                                <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>Work in Progress</p>
                                                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                                    <button className="btn-save" onClick={handleSaveConfirm}>
                                                        OK
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>

                        {/* Single‐row Drawer (unchanged) */}
                        <div className="drawer-container" ref={drawerContainerRef}>
                            {/* Single‐row Drawer (unchanged) */}
                            {drawerOpen && selectedRow && (() => {
                                const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                                const total = Number(selectedRow.available || 0) + pendingCount;
                                return (
                                    <>
                                        <div className="drawer-overlay main-drawer-overlay" />
                                        <div className="entity-drawer" ref={drawerRef}>
                                            <div className="drawer-header">
                                                <h3>Stock Info</h3>
                                                <button
                                                    className="close-btn"
                                                    onClick={() => {
                                                        setDrawerOpen(false);
                                                        setSelectedIds(ids => ids.filter(id => id !== selectedRow?.id));
                                                        setSelectedRow(null);
                                                    }}
                                                >
                                                    <X size={24} />
                                                </button>
                                            </div>
                                            <div className="main-drawer-inner">
                                                <div className="drawer-title d-flex align-items-center justify-content-between">
                                                    <div className='d-flex align-items-center'>
                                                        <img
                                                            src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                                                            alt="avatar"
                                                            className="avatar"
                                                            style={{
                                                                width: 40,
                                                                height: 40,
                                                                marginRight: 8,
                                                                verticalAlign: 'middle'
                                                            }}
                                                        />
                                                        <h2 className='pb-0'>{selectedRow?.name}</h2>
                                                    </div>
                                                    <div className='entities-tab flex-row align-items-center gap-3'>
                                                        <div class="main-company-body-inner">
                                                            <div class="edit-organisation-info d-flex justify-content-end align-items-center gap-2 p-0">
                                                                <button class="dark-border gray-btn" type="button"
                                                                    onClick={() => setSaveModalOpen(true)}>Edit</button>
                                                            </div>
                                                        </div>
                                                        <div className='toolbar'>
                                                            <div className="toolbar-right" style={{ position: "relative" }} ref={toolbarRef}>
                                                                <button
                                                                    className="drawer-dots"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleToolbarDropdown();
                                                                    }}
                                                                >
                                                                    <MoreHorizontal size={18} />
                                                                </button>

                                                                {toolbarDropdownOpen && (
                                                                    <div
                                                                        className="backdrop-cls"
                                                                        style={{
                                                                            position: "absolute",
                                                                            top: 40,
                                                                            right: 0,
                                                                            background: "white",
                                                                            boxShadow: "0px 1px 4px 0px #0000001A",
                                                                            zIndex: 1000,
                                                                            minWidth: 152,
                                                                            borderRadius: 8,
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <div className="btn-align-forall">
                                                                            <div className="common-for-all">
                                                                                <button onClick={() => {
                                                                                    setInstancesDrawerOpen(true);
                                                                                    setDrawerOpen(false);
                                                                                }}>View Instances</button>
                                                                            </div>
                                                                            <div className="common-for-all">
                                                                                <button onClick={() => alert("Deactivate clicked")}>Deactivate</button>
                                                                            </div>
                                                                            <div className="common-for-all">
                                                                                <button className="deactivate-cls">
                                                                                    Archive
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="drawer-tabs">
                                                    <button
                                                        className={drawerTab === 'entity-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('entity-info')}
                                                    >
                                                        Product Info
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'stock-instances' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('stock-instances')}
                                                    >
                                                        Stock Instances
                                                    </button>
                                                    <button
                                                        className={drawerTab === 'additional-info' ? 'active' : ''}
                                                        onClick={() => setDrawerTab('additional-info')}
                                                    >
                                                        Additional Info
                                                    </button>
                                                </div>

                                                <div className="drawer-content">
                                                    {drawerTab === 'entity-info' && (
                                                        <div className="tab-panel entity-info-panel">
                                                            <div className="field-block">
                                                                <div className="field-label">SPU & SKU</div>
                                                                <div className="field-value" style={{ marginBottom: '10px' }}>{selectedRow.name}</div>
                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    <span style={{ fontWeight: 600 }}>Color:</span> {selectedRow.variant?.split(',')[0] || '-'}
                                                                </div>
                                                                <div className="field-value" style={{ gap: '4px' }}>
                                                                    <span style={{ fontWeight: 600 }}>Storage:</span> {selectedRow.variant?.split(',')[1]?.trim() || '-'}
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Condition</div>
                                                                <div className="field-value gap-2">
                                                                    <span className={`status ${selectedRow.condition.toLowerCase()}`}>
                                                                        {selectedRow.condition}
                                                                    </span>
                                                                    <span className={`status ${selectedRow.grading.toLowerCase()}`}>
                                                                        {selectedRow.grading}
                                                                    </span>
                                                                </div>
                                                                {/* <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                <span style={{ fontWeight: 600 }}>Activation Status:</span> {selectedRow.grading}
                                                            </div>
                                                            <div className="field-value" style={{ gap: '4px' }}>
                                                                <span style={{ fontWeight: 600 }}>Condition Grade:</span> {selectedRow.condition}
                                                            </div> */}
                                                            </div>


                                                            <div className="field-block">
                                                                <div className="field-label">Open ID</div>
                                                                <div className="field-value d-flex align-items-center gap-2">
                                                                    <span style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")}>
                                                                        8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                                                    </span>
                                                                    <Copy size={13} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")} style={{ cursor: "pointer", color: "#2C7BE5" }} />
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Status</div>
                                                                <div className="field-value">
                                                                    <span className={`status ${selectedRow.status.toLowerCase()}`}>
                                                                        {selectedRow.status}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">ID</div>
                                                                <div className="field-value">{selectedRow.iD}</div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Brand</div>
                                                                <div className="field-value">
                                                                    {selectedRow.brand}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Category</div>
                                                                <div className="field-value">
                                                                    Smart Device &gt; {selectedRow.category}
                                                                </div>
                                                            </div>
                                                            <div className="field-block">
                                                                <div className="field-label">Reserved</div>
                                                                <div className="field-value">
                                                                    {selectedRow.reserved}
                                                                </div>
                                                            </div>

                                                            <div className="field-block">
                                                                <div className="field-label">Quantity</div>

                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    Total: {total}
                                                                </div>

                                                                <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                    Available: {selectedRow.available}
                                                                </div>

                                                                <div className="field-value" style={{ gap: '4px' }}>
                                                                    Pending: {pendingCount}
                                                                </div>

                                                                <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: '150px' }}>
                                                                        {selectedRow.pending?.map((p, i) => (
                                                                            <div
                                                                                key={i}
                                                                                className='field-value'
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                }}
                                                                            >
                                                                                <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                <span style={{ marginRight: 4 }}>{p.type}</span>
                                                                                <span style={{ marginLeft: 'auto', marginRight: '8px' }}>{p.count}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'stock-instances' && (
                                                        <div className="tab-panel stock-instances-panel">
                                                            <div className='entities-tab' style={{ padding: 0, paddingTop: '20px' }}>
                                                                <div className="toolbar">
                                                                    <div className="toolbar-left">
                                                                        <div className="search-box">
                                                                            <Search size={20} />
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Search…"
                                                                                value={imeiSearchInput}
                                                                                onChange={e => {
                                                                                    setImeiSearchInput(e.target.value);
                                                                                    setPageInView(1); // reset pagination if needed
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <button className="icon-btn" onClick={() => {
                                                                            setTempSelectedStock(selectedStock);
                                                                            setStockfilterDrawerOpen(true);
                                                                        }}>
                                                                            <Funnel size={18} /> Filter
                                                                            {selectedStock.length > 0 && (
                                                                                <span style={{
                                                                                    background: '#212529',
                                                                                    color: '#fff',
                                                                                    borderRadius: '50%',
                                                                                    fontSize: '12px',
                                                                                    width: 20,
                                                                                    height: 20,
                                                                                    display: 'inline-flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginLeft: 6
                                                                                }}>
                                                                                    {selectedStock.length}
                                                                                </span>
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div className='row gy-3 gy-md-0'>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Reserved</p>
                                                                            <h6 style={{ fontSize: 28, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal', marginBottom: 0, marginTop: 'auto' }}>{imeiStats.reserved}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Available</p>
                                                                            <h6 style={{ fontSize: 28, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal', marginBottom: 0, marginTop: 'auto' }}>{imeiStats.available}</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-4 d-flex'>
                                                                        <div style={{ border: '1px solid #DEE2E6', borderRadius: 8, padding: 10, textAlign: 'right', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                                                            <p style={{ fontSize: 14, fontWeight: 600, color: '#212529', fontFamily: 'Montserrat, sans-serif', lineHeight: 'normal' }}>Pending</p>
                                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                                {Object.entries(imeiStats.pendingTotals).map(([type, data]) => (
                                                                                    <div key={type} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                                        <span style={{ color: data.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                        <span style={{ color: "#6C757D", marginRight: 8 }}>{type}</span>
                                                                                        <span style={{ marginLeft: "auto", color: '#212529' }}>{data.count}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='table-wrapper'>
                                                                    <table className="entities-table" ref={tableRef} style={{ minWidth: "unset" }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th><span>IMEI/Barcode <ChevronsUpDown size={10} /></span></th>
                                                                                <th><span>Branch <ChevronsUpDown size={10} /></span></th>
                                                                                <th>
                                                                                    <span>
                                                                                        Reserved <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th>
                                                                                    <span>
                                                                                        Available <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th>
                                                                                    <span>
                                                                                        Pending <ChevronsUpDown size={12} />
                                                                                    </span>
                                                                                </th>
                                                                                <th className="sticky-action-col" style={{ textAlign: 'center' }}>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {visibleImeiRows.map((item, idx) => (
                                                                                <tr key={idx} className={idx % 2 === 1 ? 'striped' : ''}>
                                                                                    <td className='py-3'>
                                                                                        <a
                                                                                            href="#"
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            className="d-flex align-items-center gap-1 me-3"
                                                                                            style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px' }}
                                                                                        >
                                                                                            {item.imei}
                                                                                            <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                                        </a>
                                                                                    </td>
                                                                                    <td className='py-3'>{item.location}</td>
                                                                                    <td>{item.reserved}</td>
                                                                                    <td>{item.available}</td>
                                                                                    <td>
                                                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                                                            {item.pending.map((p, i) => (
                                                                                                <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: 11 }}>
                                                                                                    <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                                                    <span style={{ color: "#6C757D", marginRight: 8 }}>{p.type}</span>
                                                                                                    <span style={{ marginLeft: "auto", marginRight: "8px" }}>{p.count}</span>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </td>

                                                                                    <td className="sticky-action-col" style={{ textAlign: "center", position: "relative" }}>
                                                                                        <button
                                                                                            className="icon-btn"
                                                                                            onClick={e => {
                                                                                                e.stopPropagation();
                                                                                                setImeiDropdownOpenId(prevId => (prevId === item.id ? null : item.id));
                                                                                            }}
                                                                                        >
                                                                                            <MoreHorizontal size={20} />
                                                                                        </button>

                                                                                        {imeiDropdownOpenId === item.id && (
                                                                                            <div
                                                                                                className="backdrop-cls"
                                                                                                style={{
                                                                                                    position: "absolute",
                                                                                                    top: "40px",
                                                                                                    right: "0",
                                                                                                    background: "white",
                                                                                                    boxShadow: "0px 1px 4px 0px #0000001A",
                                                                                                    zIndex: 1000,
                                                                                                    minWidth: 152,
                                                                                                    borderRadius: 8,
                                                                                                }}
                                                                                                onClick={e => e.stopPropagation()}
                                                                                            >
                                                                                                <div className="btn-align-forall">
                                                                                                    <div className="common-for-all">
                                                                                                        <button className="deactivate-cls">Stock Out</button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </td>

                                                                                </tr>
                                                                            ))}
                                                                            {visibleImeiRows.length === 0 && (
                                                                                <tr>
                                                                                    <td colSpan="5" className="py-3 text-center">No results found.</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {drawerTab === 'additional-info' && (
                                                        <div className="tab-panel additional-info-panel">
                                                            <p className="note-type-added">Note</p>
                                                            <label className="no-description-cls">No Description</label>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                );

                            })()}

                            {stockfilterDrawerOpen && (() => {

                                return (

                                    <>
                                        <div
                                            className="drawer-overlay filter-drawer-overlay"
                                            onMouseDown={(e) => {
                                                // stop event from reaching document click handlers (so main drawer doesn't close)
                                                e.stopPropagation();
                                                setStockfilterDrawerOpen(false); // clicking overlay closes only the filter drawer
                                            }}
                                        />

                                        <div className="filter-drawer" ref={filterDrawerRef}>
                                            <div className="drawer-header">
                                                <div className="d-flex align-items-center gap-1">
                                                    <h3>Filter</h3>
                                                </div>

                                                <button
                                                    className="close-btn"
                                                    onClick={() => {
                                                        setStockfilterDrawerOpen(false); // just close the filter drawer, leave main drawer as-is
                                                    }}
                                                >
                                                    <X size={24} />
                                                </button>
                                            </div>
                                            <div className='main-company-body-inner d-flex flex-column h-100'>
                                                <div className="main-drawer-inner">
                                                    {/* ─── ROW 1: Branch ─────────────────────────────────────── */}
                                                    <div className='row gappingcls-added'>
                                                        <div className='col-12'>
                                                            <div
                                                                className="info-inner"
                                                                ref={stockRef}
                                                                style={{ position: 'relative' }}
                                                            >
                                                                <label className="form-label d-flex align-items-center gap-2">
                                                                    Branch
                                                                </label>

                                                                {/* CLOSED VIEW: tags + arrow */}
                                                                <div
                                                                    className="select-box form-control common-input-all"
                                                                    onClick={toggleStock}
                                                                    style={{
                                                                        padding: '0.5rem',
                                                                        minHeight: '40px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        flexWrap: 'wrap',
                                                                        position: 'relative',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {tempSelectedStock.length > 0 ? (
                                                                        tempSelectedStock.map((d) => (
                                                                            <span
                                                                                key={d.value}
                                                                                className="tag"
                                                                                style={{
                                                                                    backgroundColor: '#FFEB00',
                                                                                    color: '#212529',
                                                                                    borderRadius: '16px',
                                                                                    padding: '4px 8px',
                                                                                    margin: '2px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    fontSize: '12px',
                                                                                    fontWeight: '600',
                                                                                    lineHeight: 'normal',
                                                                                }}
                                                                            >
                                                                                {d.label}
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setTempSelectedStock((prev) =>
                                                                                            prev.filter((item) => item.value !== d.value)
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        background: 'none',
                                                                                        border: 'none',
                                                                                        marginLeft: '20px',
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '16px',
                                                                                        padding: '0',
                                                                                        lineHeight: '14px',
                                                                                    }}
                                                                                >
                                                                                    <X size={14} strokeWidth={3} />
                                                                                </button>
                                                                            </span>
                                                                        ))
                                                                    ) : (
                                                                        <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                                            Select Branch
                                                                        </span>
                                                                    )}

                                                                    {/* Selected count */}
                                                                    <span
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginLeft: 'auto',
                                                                            gap: '0.25rem',
                                                                            fontSize: '0.8rem',
                                                                            color: '#666',
                                                                        }}
                                                                    >
                                                                        <ChevronDown
                                                                            size={16}
                                                                            style={{
                                                                                transform: isStockOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                                transition: 'transform 0.2s',
                                                                                userSelect: 'none',
                                                                            }}
                                                                        />
                                                                    </span>
                                                                </div>

                                                                {/* DROPDOWN PANEL (visible when isStockOpen) */}
                                                                {isStockOpen && (
                                                                    <div
                                                                        className="options-container"
                                                                        style={{
                                                                            border: '1px solid #6c757d',
                                                                            borderRadius: '8px',
                                                                            marginTop: '4px',
                                                                            maxHeight: '270px',
                                                                            overflowY: 'auto',
                                                                            background: '#fff',
                                                                            position: 'absolute',
                                                                            top: '100%',
                                                                            left: 0,
                                                                            zIndex: 1000,
                                                                            width: '100%',
                                                                            boxshadow: '0px 1px 4px 0px #0000001A',
                                                                        }}
                                                                        onWheel={(e) => e.preventDefault()}
                                                                    >
                                                                        {/* Search input with icon */}
                                                                        <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                                            <Search
                                                                                size={18}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    top: '50%',
                                                                                    left: '18px',
                                                                                    transform: 'translateY(-50%)',
                                                                                    color: '#6C757D',
                                                                                    pointerEvents: 'none',
                                                                                }}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="search-input select-box form-control common-input-all"
                                                                                placeholder="Search..."
                                                                                value={stockSearch}
                                                                                onChange={(e) => setStockSearch(e.target.value)}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                                    fontSize: '0.9rem',
                                                                                    outline: 'none',
                                                                                }}
                                                                            />
                                                                        </div>

                                                                        {/* Options list */}
                                                                        <ul
                                                                            className="options-list custom-check"
                                                                            style={{
                                                                                listStyle: 'none',
                                                                                margin: 0,
                                                                                padding: '1.25rem',
                                                                                maxHeight: '420px',
                                                                                overflowY: 'auto',
                                                                            }}
                                                                        >
                                                                            {[...new Set(
                                                                                [
                                                                                    ...allStock.filter((d) =>
                                                                                        d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
                                                                                    ),
                                                                                    ...tempSelectedStock.filter(
                                                                                        (s) => !allStock.some((d) => d.value === s.value)
                                                                                    ),
                                                                                ]
                                                                            )].map((d) => (
                                                                                <li key={d.value} style={{ marginBottom: '0.5rem' }}>
                                                                                    <label
                                                                                        className="option-item"
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            cursor: 'pointer',
                                                                                            fontSize: '0.9rem',
                                                                                            fontWeight: 'normal',
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            checked={tempSelectedStock.some((item) => item.value === d.value)}
                                                                                            onChange={() => handleTempStockCheckbox(d)}
                                                                                            style={{ marginRight: '8px' }}
                                                                                        />
                                                                                        {d.label}
                                                                                    </label>
                                                                                </li>
                                                                            ))}

                                                                            {allStock.filter((d) =>
                                                                                d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
                                                                            ).length === 0 && tempSelectedStock.length === 0 && (
                                                                                    <li
                                                                                        style={{
                                                                                            color: '#999',
                                                                                            textAlign: 'center',
                                                                                            fontSize: '0.9rem',
                                                                                        }}
                                                                                    >
                                                                                        No branch found
                                                                                    </li>
                                                                                )}
                                                                        </ul>


                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='mt-auto main-drawer-inner'>
                                                    <div className='edit-organisation-info d-flex justify-content-end align-items-center gap-2 mt-auto'>
                                                        <button
                                                            className="dark-button"
                                                            type="button"
                                                            onClick={() => {
                                                                setStockfilterDrawerOpen(false);
                                                                setTempSelectedStock(selectedStock); // discard any changes, keep main drawer visible
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>

                                                        <button
                                                            className="dark-border"
                                                            type="button"
                                                            onClick={() => {
                                                                setSelectedStock(tempSelectedStock); // apply the filter
                                                                setStockfilterDrawerOpen(false); // close only the filter drawer
                                                            }}
                                                        >
                                                            Filter
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                );
                            })()}
                        </div>


                        {instancesDrawerOpen && selectedRow && (() => {
                            // Safely compute values here
                            const pendingCount = selectedRow.pending?.reduce((sum, item) => sum + item.count, 0) || 0;
                            const total = Number(selectedRow.available || 0) + pendingCount;

                            return (

                                <>
                                    <div className="drawer-overlay" />
                                    <div className="entity-drawer" ref={drawerRef}>
                                        <div className="drawer-header">
                                            <div className="d-flex align-items-center gap-1">
                                                <button
                                                    className="back-btn"
                                                    onClick={() => {
                                                        setInstancesDrawerOpen(false);
                                                        setDrawerOpen(true);
                                                    }}
                                                    style={{ backgroundColor: 'transparent', border: 'none', padding: 0, margin: 0 }}
                                                >
                                                    <ChevronLeft />
                                                </button>
                                                <h3>Stock Instance Info</h3>
                                            </div>

                                            <button
                                                className="close-btn"
                                                onClick={() => {
                                                    setInstancesDrawerOpen(false);
                                                }}
                                            >
                                                <X size={24} />
                                            </button>
                                        </div>

                                        <div className="main-drawer-inner">
                                            <div className="drawer-title d-flex align-items-center justify-content-between">
                                                <div className='d-flex align-items-center'>
                                                    <img
                                                        src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                                                        alt="avatar"
                                                        className="avatar"
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            marginRight: 8,
                                                            verticalAlign: 'middle'
                                                        }}
                                                    />
                                                    <h2 className='pb-0'>35334107 123456 2</h2>
                                                </div>
                                                <div className='entities-tab flex-row align-items-center gap-3'>
                                                    <div className='toolbar'>
                                                        <div className="toolbar-right" style={{ position: "relative" }} ref={toolbarRef}>
                                                            <button
                                                                className="drawer-dots"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleToolbarDropdown2();
                                                                }}
                                                            >
                                                                <MoreHorizontal size={18} />
                                                            </button>

                                                            {toolbarDropdownOpen2 && (
                                                                <div
                                                                    className="backdrop-cls"
                                                                    style={{
                                                                        position: "absolute",
                                                                        top: 40,
                                                                        right: 0,
                                                                        background: "white",
                                                                        boxShadow: "0px 1px 4px 0px #0000001A",
                                                                        zIndex: 1000,
                                                                        minWidth: 152,
                                                                        borderRadius: 8,
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <div className="btn-align-forall">
                                                                        <div className="common-for-all">
                                                                            <button onClick={() => {
                                                                                setStockoutModalOpen(true);
                                                                            }}>Stock Out</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                            <div className="drawer-tabs">
                                                <button
                                                    className={drawerTab2 === 'entity-info2' ? 'active' : ''}
                                                    onClick={() => setDrawerTab2('entity-info2')}
                                                >
                                                    Stock Info
                                                </button>
                                                <button
                                                    className={drawerTab2 === 'additional-info' ? 'active' : ''}
                                                    onClick={() => setDrawerTab2('additional-info')}
                                                >
                                                    Additional Info
                                                </button>
                                            </div>

                                            <div className="drawer-content">
                                                {drawerTab2 === 'entity-info2' && (
                                                    <div className="tab-panel entity-info-panel">
                                                        <div className="field-block">
                                                            <div className="field-label">IMEI/Barcode</div>
                                                            <div className="field-value">35334107 123456 2</div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Open ID</div>
                                                            <div className="field-value d-flex align-items-center gap-2">
                                                                <span style={{ color: "#2C7BE5", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")}>
                                                                    8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                                                </span>
                                                                <Copy size={13} onClick={() => navigator.clipboard.writeText("8d5815b4-38d2-405c-86c0-3366fa7cbccc")} style={{ cursor: "pointer", color: "#2C7BE5" }} />
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Status</div>
                                                            <div className="field-value">
                                                                <span className={`status ${selectedRow.status.toLowerCase()}`}>
                                                                    {selectedRow.status}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">ID</div>
                                                            <div className="field-value">{selectedRow.iD}</div>
                                                        </div>
                                                        <div className="field-block">
                                                            <div className="field-label">Branch</div>
                                                            <div className="field-value">
                                                                <a
                                                                    href="#"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="d-flex align-items-center gap-1 me-3"
                                                                    style={{ color: '#2C7BE5', textDecoration: 'underline', fontWeight: '600', fontSize: '12px' }}
                                                                >
                                                                    Bedok
                                                                    <SquareArrowOutUpRight size={14} strokeWidth={3} />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="field-block">
                                                            <div className="field-label">Reserved</div>
                                                            <div className="field-value">
                                                                {selectedRow.reserved}
                                                            </div>
                                                        </div>

                                                        <div className="field-block">
                                                            <div className="field-label">Quantity</div>

                                                            <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                Total: {total}
                                                            </div>

                                                            <div className="field-value" style={{ marginBottom: '2px', gap: '4px' }}>
                                                                Available: {selectedRow.available}
                                                            </div>

                                                            <div className="field-value" style={{ gap: '4px' }}>
                                                                Pending: {pendingCount}
                                                            </div>

                                                            <div style={{ marginLeft: '10px', marginTop: '5px' }}>
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxWidth: '150px' }}>
                                                                    {selectedRow.pending?.map((p, i) => (
                                                                        <div
                                                                            key={i}
                                                                            className='field-value'
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                            }}
                                                                        >
                                                                            <span style={{ color: p.color, fontSize: 14, marginRight: 6 }}>●</span>
                                                                            <span style={{ marginRight: 4 }}>{p.type}</span>
                                                                            <span style={{ marginLeft: 'auto', marginRight: '8px' }}>{p.count}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">First Stock In Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">First Stock In Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock In Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock In Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field-block gy-3 gy-md-0 row">
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock Out Time</div>
                                                                <div className="field-value">
                                                                    2024-12-01 23:34
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="field-label">Last Stock Out Channel</div>
                                                                <div className="field-value">
                                                                    Purchase
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {drawerTab2 === 'additional-info' && (
                                                    <div className="tab-panel additional-info-panel">
                                                        <p className="note-type-added">Note</p>
                                                        <label className="no-description-cls">No Description</label>
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </>
                            );
                        })()}

                        {stockoutModalOpen && (
                            <>
                                {/* Overlay backdrop */}
                                <div className="drawer-overlay" />

                                <div className="entity-drawer modal-popup-cls" ref={stockoutRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}>
                                    {/* Header */}
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setStockoutModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>

                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Initiate Stock Out</h3>
                                    {/* Subtext */}
                                    <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
                                        Initiating a stock-out means marking the item as no longer part of active inventory. This action only applies to cases such as loss, scrap, or other non-sale or gift removals.
                                    </p>

                                    {/* Form Content */}
                                    <div className="drawer-content">
                                        <div className="row gappingcls-added">
                                            <div className="col-12">
                                                <div className="info-inner tab-panel">
                                                    <div className='field-block'>
                                                        <div className='field-label' style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                            Stock Out <span className="error-color" style={{ color: "red" }}>*</span>
                                                            <Tooltip content="Choose Stock Out">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>
                                                        <select className="form-select new-form-select-cls">
                                                            <option value="">Select Stock Out</option>
                                                            <option value="Loss">Loss</option>
                                                            <option value="Out">Out</option>
                                                        </select>
                                                    </div>
                                                    <div className="field-block">
                                                        <div
                                                            className="field-label"
                                                            style={{ display: 'flex', gap: '4px', alignItems: 'center' }}
                                                        >
                                                            Quantity <span className="error-color" style={{ color: 'red' }}>*</span>
                                                            <Tooltip content="Choose Quantity">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>

                                                        <div className="custom-quantity-wrapper">
                                                            <input
                                                                type="number"
                                                                value={quantity}
                                                                onChange={(e) => setQuantity(Number(e.target.value))}
                                                                className="custom-quantity-input"
                                                            />
                                                            <div className="custom-spinner">
                                                                <ChevronUp size={16} onClick={handleIncrease} className="spinner-icon" />
                                                                <ChevronDown size={16} onClick={handleDecrease} className="spinner-icon" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='field-block'>
                                                        <div className='field-label' style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                            Reason <span className="error-color" style={{ color: "red" }}>*</span>
                                                            <Tooltip content="Choose Reason">
                                                                <Info size={16} className="info-icon" />
                                                            </Tooltip>
                                                        </div>
                                                        <textarea
                                                            className="form-control w-100 common-textarea-all"
                                                            id="exampleFormControlTextarea1"
                                                            rows="3"
                                                            name="Reason"
                                                            style={{
                                                                borderColor: '#6c757d',
                                                                borderRadius: '8px',
                                                                resize: 'none',
                                                                height: '120px',
                                                                overflowY: 'auto',
                                                                fontFamily: '"Montserrat", sans-serif',
                                                                color: '#6c757d',
                                                                fontSize: '14px',
                                                                fontWeight: 400,
                                                                lineHeight: '18px',
                                                                boxShadow: 'none',
                                                            }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Footer */}
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-cancel" onClick={() => setStockoutModalOpen(false)}>
                                            Cancel
                                        </button>
                                        <button className="btn-save" onClick={handleStockoutConfirm}>
                                            Stock Out
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}

                        {archivedModalOpen && (
                            <>
                                {/* Overlay backdrop */}
                                <div className="drawer-overlay" />

                                <div className="entity-drawer modal-popup-cls" ref={archivedRef}
                                    style={{
                                        maxWidth: 650,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}>
                                    {/* Header */}
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>

                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Branch can’t be archived</h3>
                                    {/* Subtext */}
                                    <p style={{ marginBottom: "0", textAlign: "left", color: "#6C757D", fontSize: "14px", fontWeight: "400", lineHeight: "20px", fontFamily: "Montserrat" }}>
                                        Branch stocked with items can’t be archived, clear stock before archiving. Archive action is also subject to approval
                                    </p>

                                    {/* Footer */}
                                    <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                                        <button className="btn-save" onClick={handleArchivedConfirm}>
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>


        </div>
    );
};
